/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface SearchFeedbackCreateSchema {
  satisfied: boolean;
  comment?: string | null;
  /** @minimum 1 */
  page: number;
}
